import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import Autolinker from 'autolinker';

class FsLinkDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._autolinker = null;
        this.httpPrefix = false;
        this.newWindow = false;
        this.openWindow = false;
        this.replaced = new EventEmitter();
        this._el = this.elementRef.nativeElement;
    }
    ngAfterViewInit() {
        if (this._el.tagName === 'A') {
            if (this.httpPrefix) {
                const href = this._el.attributes.getNamedItem('href');
                if (href && !href.value.match(/^http/i)) {
                    href.value = 'http://' + href.value;
                }
            }
            this.bindOpenWindow(this._el);
        }
        else {
            this.linkify();
        }
    }
    bindOpenWindow(el) {
        if (this.openWindow) {
            el.addEventListener('click', this.clickOpenWindow.bind(this, el));
        }
    }
    clickOpenWindow(el, e) {
        const href = el.attributes.getNamedItem('href');
        if (href && !href.value.match(/^(mailto:|tel:|maps:)/i)) {
            e.preventDefault();
            // _system supports desktop as well as cordova
            if (window.cordova && window.cordova.InAppBrowser) {
                window.cordova.InAppBrowser.open(href.value, '_system');
            }
            else {
                window.open(href.value, '_system');
            }
        }
    }
    linkify() {
        const config = {
            urls: {
                schemeMatches: true,
                wwwMatches: true,
                tldMatches: true
            },
            email: true,
            phone: true,
            mention: false,
            hashtag: false,
            stripPrefix: true,
            stripTrailingSlash: true,
            newWindow: this.newWindow,
            truncate: {
                length: 0,
                location: 'end'
            },
            className: '',
            replaceFn: () => {
                this.replaced.emit();
            }
        };
        this._autolinker = new Autolinker(config);
        this._el.innerHTML = this._autolinker.link(this._el.innerHTML);
        if (this.openWindow) {
            this._el.querySelectorAll('a')
                .forEach(el => {
                this.bindOpenWindow(el);
            });
        }
    }
}
FsLinkDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
FsLinkDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "12.2.16", type: FsLinkDirective, selector: "[fsLink]", inputs: { httpPrefix: "httpPrefix", newWindow: "newWindow", openWindow: "openWindow" }, outputs: { replaced: "replaced" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[fsLink]'
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { httpPrefix: [{
                type: Input
            }], newWindow: [{
                type: Input
            }], openWindow: [{
                type: Input
            }], replaced: [{
                type: Output
            }] } });

class FsLinkModule {
}
FsLinkModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsLinkModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkModule, declarations: [FsLinkDirective], imports: [
        // Angular
        CommonModule], exports: [FsLinkDirective] });
FsLinkModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkModule, providers: [], imports: [[
            // Angular
            CommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: FsLinkModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        // Angular
                        CommonModule,
                    ],
                    exports: [
                        FsLinkDirective
                    ],
                    entryComponents: [],
                    declarations: [
                        FsLinkDirective
                    ],
                    providers: [],
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsLinkDirective, FsLinkModule };
